import type { ReactNode } from 'react';
import { Nombre } from '../../../composants/ui/index.ts';
import type { Tableau } from '../types.ts';

/**
 * Alertes stock, en détail — RG-186.
 *
 * Une ligne de registre par produit sous son seuil, la quantité en évidence
 * plutôt que noyée dans un badge : c'est le nombre qu'on compare au seuil
 * d'un coup d'œil pour juger si ça peut attendre demain.
 */
export function BlocStocks({
  stocks,
  surOuvrir,
}: {
  stocks: NonNullable<Tableau['stocks_faibles']>;
  surOuvrir: (() => void) | undefined;
}): ReactNode {
  const tries = [...stocks].sort((a, b) => a.quantite - b.quantite);

  return (
    <div className="tdb-panneau">
      <header className="tdb-panneau__tete">
        <h2>Alertes stock, en détail</h2>
        <p>Produits sous leur seuil de réapprovisionnement</p>
      </header>

      {tries.length === 0 ? (
        <p className="table-vide">
          Aucun produit sous son seuil. Les seuils se règlent sur la fiche produit.
        </p>
      ) : (
        tries.slice(0, 6).map((ligne) => (
          <div
            key={`${ligne.produit_id}-${ligne.boutique_id}`}
            className={
              ligne.quantite <= 0
                ? 'tdb-stock-ligne tdb-stock-ligne--brick'
                : 'tdb-stock-ligne tdb-stock-ligne--rust'
            }
          >
            <div className="tdb-stock-ligne__nom">
              <strong>{ligne.designation}</strong>
              <span>
                {ligne.boutique_code !== '' ? `${ligne.boutique_code} · ` : ''}
                réf. {ligne.reference}
              </span>
            </div>
            <div className="tdb-stock-ligne__qte mono">
              <Nombre valeur={ligne.quantite} />
              <small>seuil {ligne.seuil}</small>
            </div>
          </div>
        ))
      )}

      {tries.length > 0 && surOuvrir !== undefined && (
        <button type="button" className="tdb-lien" onClick={surOuvrir}>
          Ouvrir l’état du stock
        </button>
      )}
    </div>
  );
}
